import dayjs from '@disco/utils/dayjs'
import React from 'react'
import Icon from 'components/ui/icon'
import Tooltip from 'components/ui/tooltip'
import styles from './index.module.css'

type Props = {
  date: string | Date | null | undefined
  pending?: boolean
}

// TODO: Rename and move to common components
/**
 * A component that displays a calendar icon with tooltip for release dates, with special styling for pending releases
 * @param date - The release date to display (string, Date, or null/undefined)
 * @param pending - Whether to only show the component for pending (future) releases
 * @returns Calendar icon with tooltip showing release date, or null if conditions aren't met
 */
const PreRelease = ({ date, pending }: Props) => {
  const isPending: boolean = dayjs(date).isAfter(Date.now())
  if (!date || (pending && !isPending)) return null
  return (
    <div className={styles.preRelease}>
      <Tooltip content={`Release date ${date}`}>
        <Icon
          color={isPending ? '#fece2f' : undefined}
          type="calendar"
          width={16}
          height={16}
        />
      </Tooltip>
    </div>
  )
}

export default React.memo<Props>(PreRelease)
